import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 13a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4l0 -2","key":"svg-0"}],["path",{"d":"M4 14h16","key":"svg-1"}],["path",{"d":"M8 5h6a2 2 0 0 1 2 2v2","key":"svg-2"}]]

const IconCurling = createReactComponent('outline', 'curling', 'Curling', __iconNode);

export default IconCurling;